import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './Login.css';
import awsExports from './Config';
import Dashboard from './Dashboard';
import EditDetail from './editdetail';

Amplify.configure(awsExports);

function Login() {
  return (
    <Router>
      <div className="login-container">
        <Authenticator
          hideSignUp={true}
          components={{
            SignIn: {
              Header() {
                return (
                  <div className="login-header">
                    <h2>Sign In</h2>
                  </div>
                );
              },
              Footer() {
                return null;
              },
            },
          }}
        >
          {({ signOut, user }) => (
            <>
              {/* Top Bar - Includes Welcome Message & Sign Out Button */}
              <div className="top-bar">
                <h1 className="welcome-message">
                  Welcome, {user?.signInDetails?.loginId || 'User'}
                </h1>
                <button className="signout-btn" onClick={signOut}>
                  Sign out
                </button>
              </div>

              <div className="auth-content">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/edit/:dev_id" element={<EditDetail />} />
                </Routes>
              </div>
            </>
          )}
        </Authenticator>
      </div>
    </Router>
  );
}

export default Login;
